import { render, staticRenderFns } from "./ProfileSet.vue?vue&type=template&id=0c979549&scoped=true"
import script from "./ProfileSet.vue?vue&type=script&lang=js"
export * from "./ProfileSet.vue?vue&type=script&lang=js"
import style0 from "./ProfileSet.vue?vue&type=style&index=0&id=0c979549&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c979549",
  null
  
)

export default component.exports